import { clsx } from 'clsx';

interface LoaderProps {
    height?: 'auto' | 'screen';
}

// SVG circle settings for the spinner.
const loaderRadius = 23;
const loaderCircumference = 2 * Math.PI * loaderRadius;
const loaderVisibleArcFraction = 0.75;

const Loader = ({ height = 'auto' }: LoaderProps) => (
    <div
        className={clsx(
            'flex items-center justify-center p-3',
            height === 'auto' && 'h-auto',
            height === 'screen' && 'h-screen'
        )}
    >
        <svg
            className="size-[50px] animate-spin text-teal-600"
            viewBox="0 0 50 50"
            fill="none"
            aria-label="Loading"
            role="status"
        >
            <circle
                cx="25"
                cy="25"
                r={loaderRadius}
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray={`${loaderCircumference * loaderVisibleArcFraction} ${
                    loaderCircumference * (1 - loaderVisibleArcFraction)
                }`}
                transform="rotate(-90 25 25)"
            />
        </svg>
    </div>
);

export default Loader;
